import { render, staticRenderFns } from "./AttorneysListPage.vue?vue&type=template&id=574f80ee&scoped=true"
import script from "./AttorneysListPage.vue?vue&type=script&lang=js"
export * from "./AttorneysListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574f80ee",
  null
  
)

export default component.exports